import Vue from 'vue';

// eslint-disable-next-line no-nested-ternary
Vue.filter('timeFormat', (value, valueForNull) => (value ? Vue.moment(value).format('DD-MM-YYYY HH:mm:ss') : valueForNull ? valueForNull.toString() : ''));

Vue.filter('fromNow', (value) => (value ? Vue.moment(value).fromNow('YYYY-MM-DD HH:mm:ss') : ''));

// Per le date che l'API restituisce senza fuso ("2026-10-08 22:30:00"): sono UTC,
// come tutto il database. new Date() le leggerebbe come ora locale.
Vue.filter('utcTime', (value, format = 'DD/MM/YYYY HH:mm') => (value ? Vue.moment.utc(value).local().format(format) : ''));
